import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { ColorCheckboxOptionModel } from '../../../Common/Forms/models/color-checkbox-option.model';

export class ColorCheckboxesFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    options: ColorCheckboxOptionModel[];
    binary?: boolean;
    errorMessage?: string;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        options: ColorCheckboxOptionModel[],
        binary?: boolean,
        errorMessage?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.options = options;
        this.binary = !!binary;
        this.errorMessage = errorMessage;
    }
}
